<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import Stat from "@/components/widgets/stat";

export default {
  components: {
    Layout,
    Stat,
  },
  data() {
    return {
      loading: true,
      total: 0,
      fields: [
        { key: "name", label: "Nome", sortable: true },
        { key: "date", label: "Data", sortable: true },
        { key: "level", label: "Nível", sortable: true },
        { key: "package", label: "Plano", sortable: true },
      ],
      items: null,

      search: "",
      searchInput: "",
      sortBy: "name",
      sortDesc: false,
      currentPage: 1,
      perPage: "25",

      statData: null,

      filterLevel: "",
      filterPlan: "",
      teamLevels: [],
      plansList: [],
    };
  },
  computed: {
    filterLevelSummary() {
      if (this.filterLevel === "" || this.filterLevel == null) {
        return "Todos";
      }
      return String(this.filterLevel);
    },
    filterPlanSummary() {
      if (this.filterPlan === "" || this.filterPlan == null) {
        return "Todos";
      }
      if (this.filterPlan === "precadastro") {
        return "Pré-cadastro";
      }
      const plan = this.plansList.find((p) => String(p.id) === String(this.filterPlan));
      return plan ? plan.name : String(this.filterPlan);
    },
  },
  methods: {
    submitSearch() {
      this.search = this.searchInput;
      if (this.currentPage === 1) {
        this.getTeam();
      } else {
        this.currentPage = 1;
      }
    },
    onTeamFiltersChange() {
      if (this.currentPage === 1) {
        this.getTeam();
      } else {
        this.currentPage = 1;
      }
    },
    loadPlanOptions() {
      api
        .get("plans")
        .then((response) => {
          if (response.data.status === "success" && response.data.list) {
            this.plansList = response.data.list;
          }
        })
        .catch(() => {});
    },
    getTeam() {
      this.loading = true;
      this.items = null;

      const parts = [
        "page=" + this.currentPage,
        "per_page=" + this.perPage,
        "sort_by=" + this.sortBy,
        "sort_dir=" + (this.sortDesc ? "DESC" : "ASC"),
        "search=" + encodeURIComponent(this.search),
      ];
      if (this.filterLevel !== "" && this.filterLevel != null) {
        parts.push("level=" + encodeURIComponent(this.filterLevel));
      }
      if (this.filterPlan !== "" && this.filterPlan != null) {
        parts.push("plan=" + encodeURIComponent(this.filterPlan));
      }
      const params = parts.join("&");

      api
        .get("network/team?" + params)
        .then((response) => {
          if (response.data.status == "success") {
            this.items = response.data.list;
            this.total = response.data.total;
            if (Array.isArray(response.data.levels)) {
              this.teamLevels = response.data.levels;
            }
            this.statData = [
              {
                type: "line",
                icon: "bx bx-user-plus",
                title: "Total da Equipe",
                value: response.data.total,
              },
            ];
          } else {
            this.items = [];
            this.total = 0;
          }
        })
        .catch(() => {
          this.items = [];
          this.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.loadPlanOptions();
    this.getTeam();
  },
  watch: {
    currentPage() {
      this.getTeam();
    },
    perPage() {
      if (this.currentPage === 1) {
        this.getTeam();
      } else {
        this.currentPage = 1;
      }
    },
    sortBy() {
      if (this.currentPage === 1) {
        this.getTeam();
      } else {
        this.currentPage = 1;
      }
    },
    sortDesc() {
      if (this.currentPage === 1) {
        this.getTeam();
      } else {
        this.currentPage = 1;
      }
    },
    filterLevel() {
      this.onTeamFiltersChange();
    },
    filterPlan() {
      this.onTeamFiltersChange();
    },
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Equipe</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>Equipe</h3>
        <p></p>
      </div>
    </div>

    <div class="row">
      <div v-for="stat of statData" :key="stat.icon" class="col-md-4">
        <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" />
      </div>
    </div>

    <div id="dropdown" class="d-flex mb-4 w-100">
      <div>
        <b-dropdown variant="outline-light" block class="w-100 team-filter-dropdown">
          <template #button-content>
            <div class="d-flex justify-content-between align-items-center">
              <div class="text-left">
                <h6 class="m-0 text-secondary">Por página</h6>
                <div>{{ perPage }} itens</div>
              </div>
              <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
              </svg>
            </div>
          </template>
          <b-dropdown-form><b-form-radio v-model="perPage" value="10">10 itens</b-form-radio></b-dropdown-form>
          <b-dropdown-form><b-form-radio v-model="perPage" value="25">25 itens</b-form-radio></b-dropdown-form>
          <b-dropdown-form><b-form-radio v-model="perPage" value="50">50 itens</b-form-radio></b-dropdown-form>
          <b-dropdown-form><b-form-radio v-model="perPage" value="100">100 itens</b-form-radio></b-dropdown-form>
        </b-dropdown>
      </div>

      <div>
        <b-dropdown variant="outline-light" block class="w-100 team-filter-dropdown">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0 text-secondary">Nível</h6>
              <div>{{ filterLevelSummary }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form><b-form-radio v-model="filterLevel" :value="''">Todos</b-form-radio></b-dropdown-form>
        <b-dropdown-form v-for="level in teamLevels" :key="'lvl-' + level">
          <b-form-radio v-model="filterLevel" :value="String(level)">{{ String(level) }}</b-form-radio>
        </b-dropdown-form>
      </b-dropdown>
      </div>

      <div>
        <b-dropdown variant="outline-light" block class="w-100 team-filter-dropdown">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0 text-secondary">Plano</h6>
              <div>{{ filterPlanSummary }}</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form><b-form-radio v-model="filterPlan" :value="''">Todos</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="filterPlan" value="precadastro">Pré-cadastro</b-form-radio></b-dropdown-form>
        <b-dropdown-form v-for="plan in plansList" :key="'pln-' + plan.id">
          <b-form-radio v-model="filterPlan" :value="String(plan.id)">{{ plan.name }}</b-form-radio>
        </b-dropdown-form>
      </b-dropdown>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <b-input-group class="mb-4">
          <b-form-input v-model="searchInput" placeholder="Buscar por nome..." @keyup.enter="submitSearch"></b-form-input>
          <b-input-group-append>
            <b-button variant="default" @click="submitSearch">Buscar</b-button>
          </b-input-group-append>
        </b-input-group>

        <div v-if="!items" class="min-vh-25 d-flex justify-content-center align-items-center">
          <b-spinner variant="default" role="status"></b-spinner>
        </div>

        <div v-else-if="items && items.length == 0" class="min-vh-25 d-flex justify-content-center align-items-center">
          <div class="text-center">
            <i class="far fa-sad-cry font-size-24"></i><br>
            nenhum registro encontrado
          </div>
        </div>

        <div v-else>
          <div class="table-responsive">
            <b-table :items="items" :fields="fields" class="table-nowrap table-style table-hover" head-variant="light" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :no-local-sorting="true" responsive>
              <template #cell(package)="row">
                <span class="badge badge-soft-dark font-size-12">{{ row.item.package }}</span>
              </template>
              <template #cell(monthly)="row">
                <span v-if="row.item.monthly === 'inactive'" class="badge badge-soft-danger font-size-12">INATIVO</span>
                <span v-else-if="row.item.monthly === 'active'" class="badge badge-soft-success font-size-12">ATIVO</span>
              </template>
              <template #cell(status)="row">
                <span v-if="row.item.status === 'Pending'" class="badge badge-soft-warning font-size-12">Pendente</span>
                <span v-else-if="row.item.status === 'Approved'" class="badge badge-soft-success font-size-12">Aprovado</span>
              </template>
            </b-table>
          </div>

          <b-pagination class="mt-3" v-model="currentPage" :total-rows="total" :per-page="perPage" pills align="center"></b-pagination>
        </div>
      </div>
    </div>
  </Layout>
</template>